import React from "react";
import { useMediaQuery } from "react-responsive";
import { Design1, Design2, Design3, Design4, Design5, Wrapper } from "./style";
const DesignCom = () => {
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  return (
    <>
      {isPc && (
        <Wrapper>
          <Design1></Design1>
          <Design2></Design2>
          <Design3></Design3>
          <Design4></Design4>
          <Design5></Design5>
        </Wrapper>
      )}
    </>
  );
};

export default DesignCom;
